import ClearIcon from '@mui/icons-material/Clear';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { FC } from 'react';
import { Connection } from '@/types/connection';
import { Port } from '@/types/metadata/metadata';
import ConfirmPopover from '@/components/common/ConfirmPopover';
import ListArrows from '@/components/common/ListArrows';
import TextFieldWrapper from '@/components/common/TextFieldWrapper';

type EnumListItemProps = {
  action: string;
  label: string;
  options: Port[] | undefined;
  data: Connection[];
  index: number;
  onArrowClick: (data: Connection[]) => void;
  onChange: (action: string, label: string) => void;
  onDelete: () => void;
};

const EnumListItem: FC<EnumListItemProps> = (props) => {
  return (
    <Stack direction='row' gap={1} alignItems='center'>
      <FormControl fullWidth size='small'>
        <InputLabel id='enum-select-label'>ID</InputLabel>
        <Select
          labelId='enum-select-label'
          value={props.action}
          label='ID'
          onChange={(event) => props.onChange(event.target.value, props.label)}
        >
          {props.options?.map((port, index) => (
            <MenuItem key={`EnumListItem.${index}`} value={port.action}>
              {port.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextFieldWrapper
        size='small'
        label='Label'
        value={props.label}
        fullWidth
        sx={{ flexGrow: 1 }}
        autoFocus={!!props.action && !props.label}
        onChange={(event) => props.onChange(props.action, event.currentTarget.value)}
      />
      <ListArrows data={props.data} index={props.index} onChange={props.onArrowClick} />
      <ConfirmPopover
        onConfirm={props.onDelete}
        icon={<ClearIcon />}
        text={`Remove ${props.action}?`}
        skipConfirm={!props.action && !props.label}
      />
    </Stack>
  );
};

export default EnumListItem;
